// extracted by mini-css-extract-plugin
export default {"company_catch_phrase":"top_company_catch_phrase__NcKNz","company_catch_phrase__sp":"top_company_catch_phrase__sp__O--Mf","catch_image":"top_catch_image__3O8we"};